import { render, staticRenderFns } from "./ProductParamCreate.vue?vue&type=template&id=a5cc00fe&scoped=true"
import script from "./ProductParamCreate.vue?vue&type=script&lang=js"
export * from "./ProductParamCreate.vue?vue&type=script&lang=js"
import style0 from "./ProductParamCreate.vue?vue&type=style&index=0&id=a5cc00fe&prod&lang=styl&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5cc00fe",
  null
  
)

export default component.exports